import { useEffect } from "react";
import { useContextMenu } from "@/hooks/useContextMenu";

export function ContextMenu() {
  const { open, close } = useContextMenu();
  useEffect(() => {
    if (!open) return;
    const on = () => close();
    window.addEventListener("click", on);
    window.addEventListener("scroll", on, true);
    return () => { window.removeEventListener("click", on); window.removeEventListener("scroll", on, true); };
  }, [open, close]);
  if (!open) return null;
  return (
    <ul
      role="menu"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed", top: open.y, left: open.x, zIndex: 200,
        background: "var(--bg-elev-2)", border: "1px solid var(--line)",
        borderRadius: 10, padding: 6, listStyle: "none", minWidth: 200,
        boxShadow: "var(--shadow)",
      }}
    >
      {open.items.map((it, i) => "divider" in it ? (
        <li key={i} style={{ height: 1, background: "var(--line)", margin: "4px 8px" }} />
      ) : (
        <li key={i}>
          <button
            onClick={() => { it.onSelect(); close(); }}
            style={{
              width: "100%", textAlign: "left", padding: "8px 10px", borderRadius: 8,
              color: it.danger ? "var(--danger)" : "var(--fg)",
            }}
          >
            {it.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
